import { render } from "./ParentPwdModal.vue?vue&type=template&id=6db5fbe8&scoped=true"
import script from "./ParentPwdModal.vue?vue&type=script&lang=js"
export * from "./ParentPwdModal.vue?vue&type=script&lang=js"

import "./ParentPwdModal.vue?vue&type=style&index=0&id=6db5fbe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db5fbe8"]])

export default __exports__